<template>
    <div :id="'paypal-button-container'+this.expenseIds"></div>
</template>
<script>
// import {mapState} from 'vuex';
export default {
    name: "Payments",
    props: {
        // clientId: String,
        amount: Number,
        sponsorshipId: String,
        sponsorshipConfirm: String,
        userId: String,
        expenseIds: Array
    },
    mounted() {
        // const paypalScript = document.createElement('script');
        // paypalScript.src = 'https://www.paypal.com/sdk/js?client-id='+ this.clientId +'&currency=USD';

        // paypalScript.addEventListener('load', )
        // document.body.appendChild(paypalScript)
        this.mountPaypalbuttons()
    },
    methods: {
        mountPaypalbuttons() {
            let comp = this
            paypal.Buttons(
                {
                    style: {
                        layout: 'horizontal'
                    },

                    // Call your server to set up the transaction
                    createOrder: function (data, actions) {
                        return fetch('/api/paypal/order/create', {
                            method: 'POST',
                            body: JSON.stringify({
                                sponsorship_id: comp.sponsorshipId,
                                sponsorship_confirm: comp.sponsorshipConfirm,
                                user: comp.userId,
                                amount: comp.amount
                            }
                            )
                        }).then(function (res) {
                            //res.json();
                            return res.json();
                        }).then(function (orderData) {
                            //console.log(orderData);
                            return orderData.id;
                        });
                    },

                    // Call your server to finalize the transaction
                    onApprove: function (data, actions) {
                        return fetch('/api/paypal/order/capture', {
                            method: 'POST',
                            body: JSON.stringify({
                                sponsorship_id: comp.sponsorshipId,
                                order_id: data.orderID,
                                expense_ids: comp.expenseIds,
                                payment_gateway_id: $("#payapalId").val(),
                                user_id: comp.userId,
                            })
                        }).then(function (res) {
                            // console.log(res.json());
                            return res.json();
                        }).then(function (orderData) {

                            // Successful capture! For demo purposes:
                            //  console.log('Capture result', orderData, JSON.stringify(orderData, null, 2));
                            var transaction = orderData.purchase_units[0].payments.captures[0];
                            iziToast.success({
                                title: 'Success',
                                message: 'Payment completed',
                                position: 'topRight'
                            });
                        });
                    }
                }).render('#paypal-button-container' +  comp.expenseIds  )
        }
    }
}
</script>
